export interface TpCategoryInfo {
  value: string;
  displayString: string;
  count: number;
  countSelected: number;
}

export enum CATEGORICAL_ORDERS {
  Count = 'count',
  Alphabetical = 'alphabetical',
  Ordinal = 'ordinal',
}

export const categoricalOrderValues = Object.values(CATEGORICAL_ORDERS);
export const categoricalOrderOptions = [
  { id: CATEGORICAL_ORDERS.Count, name: 'Count' },
  { id: CATEGORICAL_ORDERS.Alphabetical, name: 'Alphabetical' },
  { id: CATEGORICAL_ORDERS.Ordinal, name: 'Ordinal' },
];

/**
 * Sort a list of categorical values in place
 * @param categories list of categorical values, including their frequency
 * @param sortBy type of sort to perform
 */
export function sortCategories(categories: TpCategoryInfo[], sortBy: CATEGORICAL_ORDERS) {
  if (sortBy == CATEGORICAL_ORDERS.Count) categories.sort((a, b) => b.count - a.count);
  if (sortBy == CATEGORICAL_ORDERS.Alphabetical) {
    categories.sort((a, b) => (a.displayString < b.displayString ? -1 : a.displayString > b.displayString ? 1 : 0));
  }
  if (sortBy == CATEGORICAL_ORDERS.Ordinal) {
    categories.sort((a, b) =>
      a.displayString.localeCompare(b.displayString, undefined, { numeric: true, sensitivity: 'base' }),
    );
  }
}
